import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';

@Pipe({
  name: 'filterBy',
  standalone: false
})
export class FilterByPipe implements PipeTransform {
  transform(collection: any[], filter: any, normal: boolean = true): any[] {
    if (!collection) return new Array<any>();

    if (!filter) return collection;

    return normal ? _.filter(collection, filter) : _.reject(collection, filter);
  }
}
